import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

const JWPlayer = ({
  videoSource = "https://cdn.jwplayer.com/manifests/RbbzytoU.m3u8",
  playerId,
  autostart = true,
  mute = true,
}) => {
  const defaultId = playerId || window.location.pathname.split("/").pop() || "default-player";
  const containerId = useRef(defaultId);
  const [isPlayerReady, setIsPlayerReady] = useState(false);
  const wasAutoPlayedOnHover = useRef(false); // Track if autoplayed by hover

  useEffect(() => {
    const loadJWPlayerScript = () => {
      return new Promise((resolve, reject) => {
        if (window.jwplayer) return resolve();

        const script = document.createElement("script");
        script.src = "https://cdn.jwplayer.com/libraries/8LwdHpsM.js";
        script.async = true;
        script.onload = resolve;
        script.onerror = () => reject(new Error("Failed to load JWPlayer script"));
        document.body.appendChild(script);
      });
    };

    const setupPlayer = async () => {
      try {
        await loadJWPlayerScript();

        const player = window.jwplayer(containerId.current);
        player.setup({
          file: videoSource,
          width: "100%",
          aspectratio: "16:9",
          autostart,
          mute,
        });

        player.on("ready", () => {
          setIsPlayerReady(true);
        });

        // Reset auto-play state when user manually plays
        player.on("play", () => {
          wasAutoPlayedOnHover.current = false;
        });

      } catch (err) {
        console.error("JWPlayer setup failed:", err);
      }
    };

    setupPlayer();

    return () => {
      if (window.jwplayer && window.jwplayer(containerId.current)) {
        window.jwplayer(containerId.current).remove();
      }
    };
  }, [videoSource, autostart, mute]);

  const handleMouseEnter = () => {
    if (!isPlayerReady) return;

    try {
      const player = window.jwplayer(containerId.current);
      if (player && typeof player.play === "function" && player.getState() !== "playing") {
        player.play().then(() => {
          wasAutoPlayedOnHover.current = true; // Set flag
        }).catch((err) => {
          console.warn("JWPlayer play() failed:", err);
        });
      }
    } catch (err) {
      console.error("Error on mouse enter play:", err);
    }
  };

  const handleMouseLeave = () => {
    if (!isPlayerReady) return;

    try {
      const player = window.jwplayer(containerId.current);
      if (
        player &&
        typeof player.pause === "function" &&
        wasAutoPlayedOnHover.current &&
        player.getState() === "playing"
      ) {
        player.pause();
        wasAutoPlayedOnHover.current = false; // Reset
      }
    } catch (err) {
      console.error("Error on mouse leave pause:", err);
    }
  };

  return (
    <div
      className="EpisodeTrailerVideo"
      // onMouseEnter={handleMouseEnter}
      // onMouseLeave={handleMouseLeave}
    >
      <div id={containerId.current}></div>
    </div>
  );
};

JWPlayer.propTypes = {
  videoSource: PropTypes.string,
  playerId: PropTypes.string,
  autostart: PropTypes.bool,
  mute: PropTypes.bool,
};

export default JWPlayer;